import { client, getErrorMessage } from "./client";

const baseUrl = "/evaluation";

const getLatestInspStatus = async (projectId: number) => {
  try {
    const response = await client.get(`${baseUrl}/${projectId}/latest-insp`);
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

const getLatestUpdatedInsp = async (projectId: number) => {
  try {
    const response = await client.get(`${baseUrl}/${projectId}/latest-update`);
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export { getLatestInspStatus, getLatestUpdatedInsp };
